module.exports = __webpack_public_path__ + "96f288685261957a62a18456f2a96997.ttf";